<div class="processing-history-template">
  <ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>

  <button mat-icon-button class="close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
